/**
 * Created by tofael on 8/2/18.
 */
import React from 'react';
import moment from 'moment';

import DateRangeSelector from './DateRangeSelector';
import MenuItem from 'material-ui/MenuItem';
import DropDownMenu from 'material-ui/DropDownMenu';
import {Toolbar, ToolbarGroup} from 'material-ui/Toolbar';

moment.lang('en', {week: {dow: 6}});

const styles = {
  toolBar:{
    backgroundColor:'#ffffff'
  }
};

class AppCharts extends React.Component {

  constructor() {
    super(...arguments);
    this.state = {
      currentRange: 0,
      customRangePickerOpen: false,
      customDateRangeLabel:'Custom Date Range'
    };
  }

  onRangeChange(event, index, value) {
    this.setState({currentRange: value});
    switch (value) {
      case 0: //last 30 days
        let thirtyDaysAgo = new Date();
        thirtyDaysAgo.setDate(thirtyDaysAgo.getDate() - 29);
        this.setState({customDateRangeLabel: 'Custom Date Range'});
        this.props.onDateRangeChange(thirtyDaysAgo.toISOString(), new Date().toISOString());
        break;
      case 1: //last 60 days
        let sixtyDaysAgo = new Date();
        sixtyDaysAgo.setDate(sixtyDaysAgo.getDate() - 59);
        this.setState({customDateRangeLabel: 'Custom Date Range'});
        this.props.onDateRangeChange(sixtyDaysAgo.toISOString(), new Date().toISOString());
        break;
      case 2: //last 90 days
        let nintyDaysAgo = new Date();
        nintyDaysAgo.setDate(nintyDaysAgo.getDate() - 89);
        this.setState({customDateRangeLabel: 'Custom Date Range'});
        this.props.onDateRangeChange(nintyDaysAgo.toISOString(), new Date().toISOString());
        break;
      case 3: //last 6 months
        let sixMonthsAgo = new Date();
        sixMonthsAgo.setDate(sixMonthsAgo.getDate() - 179);
        this.setState({customDateRangeLabel: 'Custom Date Range'});
        this.props.onDateRangeChange(sixMonthsAgo.toISOString(), new Date().toISOString());
        break;
      case 4: //last 1 year
        let oneYearAgo = new Date();
        oneYearAgo.setDate(oneYearAgo.getDate() - 364);
        this.setState({customDateRangeLabel: 'Custom Date Range'});
        this.props.onDateRangeChange(oneYearAgo.toISOString(), new Date().toISOString());
        break
      case 5: //lifetime
        let veryFirstDay = new Date(2017,11, 17);
        veryFirstDay.setDate(veryFirstDay.getDate() - 89);
        this.setState({customDateRangeLabel: 'Custom Date Range'});
        this.props.onDateRangeChange(veryFirstDay.toISOString(), new Date().toISOString());
        break
      case 6: //show date range picker
        this.handleDatePickerOpen();
        break;
      default:
        console.log(value);
    }

  }

  handleDatePickerClose() {
    this.setState({customRangePickerOpen: false});
  };

  handleDatePickerOpen() {
    this.setState({customRangePickerOpen: true});
  };

  handleCustomDateRange(startDate, endDate) {
    this.handleDatePickerClose();
    let formattedStartDate = moment(startDate).format('DD/MM/YYYY');
    let formattedEndDate = moment(endDate).format('DD/MM/YYYY');
    this.setState({customDateRangeLabel: `${formattedStartDate} - ${formattedEndDate}`});
    this.props.onDateRangeChange(startDate, endDate);
  }

  render() {
    const {currentRange, customRangePickerOpen, customDateRangeLabel} = this.state;
    return (
      <div>
        <Toolbar style={styles.toolBar}>
          <ToolbarGroup firstChild={true}>
            <DropDownMenu value={currentRange} onChange={this.onRangeChange.bind(this)} selectedMenuItemStyle={{color:'green'}}>
              <MenuItem value={0} primaryText="Last 30 Days" />
              <MenuItem value={1} primaryText="Last 60 Days" />
              <MenuItem value={2} primaryText="Last 90 Days" />
              <MenuItem value={3} primaryText="Last 6 Months" />
              <MenuItem value={4} primaryText="Last 1 Year" />
              <MenuItem value={5} primaryText="Lifetime" />
              <MenuItem value={6} primaryText={customDateRangeLabel} />
            </DropDownMenu>
          </ToolbarGroup>
          {/*<ToolbarGroup>*/}
            {/*<MenuItem*/}
              {/*primaryText={customDateRangeLabel}*/}
              {/*onClick={this.handleDatePickerOpen.bind(this)}*/}
              {/*rightIcon={<DateRange/>}*/}
              {/*hoverColor="transparent"*/}
            {/*/>*/}
          {/*</ToolbarGroup>*/}
        </Toolbar>
        <DateRangeSelector
          open={customRangePickerOpen}
          handleClose = {this.handleDatePickerClose.bind(this)}
          handleCustomDateRange = {this.handleCustomDateRange.bind(this)}
        />
      </div>
    )
  }
}

export default AppCharts;



// WEBPACK FOOTER //
// ./src/screens/stats/toolbar/index.js